<template>
  <div class="ml-6 mr-0">
    <v-btn
      v-show="!accessory.selected"
      @click="selectAccessory(true)"
      rounded
      dark
      color="#7C40DC"
      class="sigfloButtonSmall600 elevation-0 text-capitalize mr-5"
      ><v-icon class="mr-2">mdi-plus</v-icon>Add</v-btn
    >
    <v-btn
      width="110"
      v-show="accessory.selected"
      rounded
      color="#F4F2F7"
      class="sigfloButtonSmall600 textEmphasis elevation-0 text-capitalize"
    >
      <v-icon @click="selectAccessory(false)" class="mr-2" v-show="quantity <= effectiveMinQuantity"
        >mdi-delete-outline</v-icon
      >
      <v-icon @click="quantity = quantity - 1" class="mr-2" v-show="quantity > effectiveMinQuantity">mdi-minus</v-icon
      >{{ quantity
      }}<v-icon class="ml-2" v-show="quantity < accessory.maxQuantity * parentQuantity" @click="quantity = quantity + 1"
        >mdi-plus</v-icon
      >
      <v-icon class="ml-2" color="rgba(17,11,25,0.2)" v-show="quantity >= accessory.maxQuantity * parentQuantity"
        >mdi-plus</v-icon
      >
    </v-btn>
  </div>
</template>

<script>
  export default {
    props: {
      accessory: {
        type: Object,
        required: true
      },
      parentQuantity: {
        type: Number,
        required: true
      },
      productId: {
        type: Number,
        required: true
      },
      index: Number
    },
    data() {
      return {};
    },
    computed: {
      /**
       * TRUE if this accessory has settings
       */
      hasSettings: function () {
        return this.accessory.productSettingModels && this.accessory.productSettingModels.length > 0;
      },
      effectiveMinQuantity: function () {
        return this.hasSettings ? this.accessory.minQuantity : this.accessory.minQuantity * this.parentQuantity;
      },
      quantity: {
        set(value) {
          this.$store.commit('configurator/updateAccessoryQuantity', {
            productId: this.productId,
            accessoryId: this.accessory.id,
            componentProductId: this.accessory.componentProductId,
            quantity: Number(value)
          });
        },
        get() {
          return this.accessory.quantity;
        }
      }
    },
    methods: {
      raiseSigEvent: function () {
        this.$store
          .dispatch('configurator/raiseSigEvent', {
            parentType: 'ProductAccessory',
            parentEvent: 'Select',
            parentId: this.accessory.id
          })
          .then((sigMsg) => {
            if (sigMsg) {
              this.processSigResponse(sigMsg);
            }
          });
      },
      /**
       * Marks the accessory as selected/unselected
       */
      selectAccessory: function (selected) {
        // if this is a duplicated accessory, delete it.  Otherwise unselect it
        if (this.accessory.duplicate) {
          this.$emit('deleteAccessory');
        } else {
          this.$store.commit('configurator/selectAccessory', {
            selected: selected,
            productId: this.productId,
            accessoryId: this.accessory.id,
            quantity: this.accessory.quantity
          });

          if (this.accessory.sellAsType == 'Configured') {
            this.$store
              .dispatch('configurator/configureProductAccessory', {
                accessory: this.accessory,
                index: this.index
              })
              .then(() => {
                this.raiseSigEvent();
              });
          } else {
            this.raiseSigEvent();
          }
        }
      }
    }
  };
</script>
